import { getServices } from '../../../../../infra/commonInitializer';
import * as T from './types';
import matchPath from '../../../../../utils/matchPath';

export default function valueFunctionURL(
  value: T.ValueFunctionURLValueType
): boolean {
  const { navigationService, URLService } = getServices() || {};

  const currentSearch = navigationService?.location?.search;
  const currentPath = navigationService?.location?.pathname;
  const currentHash = navigationService?.location?.hash;

  const checkSearch = (search?: string | Record<string, any>) => {
    if (!search) {
      return true;
    }
    return URLService.isSearchIncluded(search, currentSearch);
  };

  const checkPathname = (pathname?: string | string[], exact?: boolean) => {
    if (!pathname) {
      return true;
    }
    return matchPath(pathname, {
      exact,
      pathToCompare: currentPath
    });
  };

  const checkHash = (hash?: string) => {
    if (!hash) {
      return true;
    }
    return currentHash === hash;
  };

  const urlList = Array.isArray(value) ? value : [value];

  return urlList?.some?.((url) => {
    if (typeof url === 'string') {
      return checkPathname(url);
    } else {
      const isValidPathname = checkPathname(url?.pathname, url?.exact);
      const isValidHash = checkHash(url?.hash);
      const isValidSearch = checkSearch(url?.search);

      return isValidPathname && isValidHash && isValidSearch;
    }
  });
}
